import { initializeApp } from 'firebase/app';
import { connectAuthEmulator, GoogleAuthProvider, getAuth, OAuthProvider } from 'firebase/auth';
import { connectFirestoreEmulator, getFirestore, initializeFirestore } from 'firebase/firestore';

// Firebase設定
const firebaseConfig = {
  apiKey: import.meta.env.VITE_FIREBASE_API_KEY,
  authDomain: import.meta.env.VITE_FIREBASE_AUTH_DOMAIN,
  projectId: import.meta.env.VITE_FIREBASE_PROJECT_ID,
  storageBucket: import.meta.env.VITE_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: import.meta.env.VITE_FIREBASE_MESSAGING_SENDER_ID,
  appId: import.meta.env.VITE_FIREBASE_APP_ID,
};

// Firebase初期化
const app = initializeApp(firebaseConfig);

// Firestore関連
const dbId = import.meta.env.VITE_FIREBASE_FIRESTORE_DATABASE || '(default)';
// DEV では既定で Docker の Firebase エミュレータに接続する。
// エミュレータを使わず実 Firebase(dev-db 等)に直接繋ぎたい場合は
// frontend/.env に VITE_USE_FIREBASE_EMULATOR=false を指定する。
const useEmulator = import.meta.env.DEV && import.meta.env.VITE_USE_FIREBASE_EMULATOR !== 'false';
// emulator(Docker)経由だと WebChannel ストリーミングが遅く初回 getDocs が固まることがあるため、
// エミュレータ接続時のみ long-polling を強制する。実 Firebase では自動検出に任せる。
const firestoreSettings = useEmulator
  ? { experimentalForceLongPolling: true }
  : { experimentalAutoDetectLongPolling: true };
export const db = (() => {
  try {
    return initializeFirestore(app, firestoreSettings, dbId);
  } catch {
    // HMR 等で再初期化された場合は既存インスタンスを返す
    return getFirestore(app, dbId);
  }
})();

// 認証関連
export const auth = getAuth(app);
const tenantId = import.meta.env.VITE_FIREBASE_AUTH_TENANT_ID;
if (tenantId) {
  auth.tenantId = tenantId;
}

export const googleProvider = new GoogleAuthProvider();

// Microsoft Entra ID (Azure AD) プロバイダー
export const microsoftProvider = new OAuthProvider('microsoft.com');
// シングルテナントアプリの場合、テナントIDを指定する必要がある
const azureTenantId = import.meta.env.VITE_AZURE_TENANT_ID;
if (azureTenantId) {
  microsoftProvider.setCustomParameters({
    tenant: azureTenantId,
  });
}

// エミュレーターの設定
if (useEmulator) {
  const firestorePort = Number(import.meta.env.VITE_FIREBASE_FIRESTORE_EMULATOR_PORT) || 8080;
  const authPort = Number(import.meta.env.VITE_FIREBASE_AUTH_EMULATOR_PORT) || 9099;

  // Firestore エミュレーター
  // Note: localhost を使用。Docker Compose 経由でブラウザからアクセスするため。
  connectFirestoreEmulator(db, 'localhost', firestorePort);

  // Auth エミュレーター
  connectAuthEmulator(auth, `http://localhost:${authPort}`);

  console.log(`🔥 Firebase Emulators connected (Firestore: ${firestorePort}, Auth: ${authPort})`);
} else if (import.meta.env.DEV) {
  console.log(`☁️  実 Firebase に接続 (project: ${firebaseConfig.projectId}, database: ${dbId})`);
}

// デフォルトエクスポート
export default app;
